import React from 'react';
import PostAdd from 'components/features/PostAdd/PostAdd';

const PostAddLayout = () => <PostAdd />;

export default PostAddLayout;
